import { render, staticRenderFns } from "./VatTypePicker.vue?vue&type=template&id=2ceaa1fa&scoped=true&"
import script from "./VatTypePicker.vue?vue&type=script&lang=js&"
export * from "./VatTypePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceaa1fa",
  null
  
)

export default component.exports